import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {HotKeys} from 'react-hotkeys';

export interface IMeshTableKeyboardShortcutsProps
{
    ctx?:IWSPMeshContext;
}

@inject('ctx')
@observer
export class MeshTableKeyboardShortcuts extends React.Component<IMeshTableKeyboardShortcutsProps, any>
{
    public render():JSX.Element
    {
        const {ctx} = this.props;

        const {meshKeyboard} = controllers.ui.spreadsheets;
        const keyMap = meshKeyboard.getKeyMap();
        const keyHandlers = meshKeyboard.getKeyHandlers(ctx);

        return (
            <HotKeys
                keyMap={keyMap}
                handlers={keyHandlers}
                onFocus={meshKeyboard.handleMeshFocus}
            >
                {this.props.children}
            </HotKeys>
        );
    }
}
